import { z } from 'zod';

const contactReasonSchema = z.object({
    label: z.string().min(1),
    value: z.string().regex(/^[a-z0-9-]+_[a-z0-9-]+$/),
});

const customFieldSchema = z.object({
    id: z.string().regex(/^[a-z][a-zA-Z0-9]*$/),
    label: z.string().min(1),
    maxLength: z.number().int().positive(),
});

const contactFormTemplateSchema = z.object({
    id: z.string().regex(/^[a-z0-9-]+$/),
    name: z.string().min(1),
    reasons: z.array(contactReasonSchema).min(1),
    customFields: z.array(customFieldSchema),
});

export type ContactFormTemplate = z.infer<typeof contactFormTemplateSchema>;

export const contactFormTemplates: ContactFormTemplate[] = z.array(contactFormTemplateSchema).parse([
    {
        id: 'man-charge-go',
        name: 'MAN Charge & Go',
        reasons: [
            { label: 'Invoices & billing', value: 'man-charge-go_invoices-and-billing' },
            { label: 'Charging cards & orders', value: 'man-charge-go_charging-cards-and-orders' },
            {
                label: 'Charging activity & sessions',
                value: 'man-charge-go_charging-activity-and-sessions',
            },
            { label: 'Charging stations & prices', value: 'man-charge-go_charging-stations-and-prices' },
            { label: 'Account & access', value: 'man-charge-go_account-and-access' },
            {
                label: 'Contract & company details',
                value: 'man-charge-go_contract-and-company-details',
            },
            { label: 'Other', value: 'man-charge-go_other' },
        ],
        customFields: [{ id: 'reference', label: 'Reference', maxLength: 80 }],
    },
]);

export const getContactFormTemplate = (templateId?: string): ContactFormTemplate | undefined =>
    contactFormTemplates.find(template => template.id === templateId);
